// random waiting message directive to entertain your users while they sit

let module = angular.module('app.directives');

const MESSAGES = [
  'Locating the required gigapixels to render...',
  'Spinning up the hamster...',
  'Shovelling coal into the server...',
  'Programming the flux capacitor...',
  'Pay no attention to the man behind the curtain...',
  'Enjoy the elevator music...',
  'This server must be powered by a lemon and two electrodes...',
  'The version I have of this in testing has much funnier waiting messages...',
  '999 bottles of soda on the wall...',
  'Searching for Answer to Life, the Universe, and Everything...',
];

module.directive('randomWaitingMessage', ($interval) => {
  'ngInject';

  return {
    restrict: 'E',
    scope: { interval: '@' },
    template: `
      <span>{{message}}</span>
    `,
    link: (scope, element) => {
      function changeMessage() {
        scope.message = _.sample(MESSAGES);
      }

      let cancelInterval = $interval(changeMessage, scope.interval);
      scope.$on('$destroy', cancelInterval);
      changeMessage();
    },
  };
});



// WEBPACK FOOTER //
// ./app/directives/random-waiting-message.js